import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: '[app-tr-purchase-order]',
  template: `  
  <td><a href="" routerLink="/inventory/purchase-orders/{{po.id}}" >{{po?.po_number}}</a></td>
  <td>{{po?.supplier?.name}}</td>
  <td class="align-middle text-center">{{po?.purchase_order_items.length}} / {{po?.line_items}} 
  <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
    <div class="progress-bar bg-success" style="width: 100%"></div>
  </div>
  </td>
  <td class="align-middle text-center">{{po?.status}}</td>
  <td class="align-middle text-center">{{po?.created_at | date: 'YYYY-MM-DD HH:mm'}}</td>
  <td class="align-middle text-center">{{po?.target_date}}</td>
  <td class="align-middle text-center">{{po?.total_amount | currency}}</td>
  <td class="align-middle text-center">{{po?.created_by?.name}}</td>  
  `,
  styleUrls: []
})
export class TrPurchaseOrderComponent {
  @Input() po: any;
  @Input() profile: any;
  @Input() permissions: any;

  

  constructor(
    
  ) {
    
  }

  
}
